import { Dropdown, Menu } from "antd";
import "./style.css";

const UIDropdown = (props: any) => {
  const menu = (
    <Menu
      items={props.items}
      // The menu renders through a portal, so a click on an item still bubbles
      // through the REACT tree and would reach an ancestor row's onClick even
      // though the item isn't a DOM descendant. Stopping it once here fixes
      // that for every caller.
      onClick={(info) => info.domEvent.stopPropagation()}
    />
  );

  return (
    <Dropdown
      className="dropdown-menu"
      // Base theme lives on "uidropdown-overlay" (dropdown/style.css); a
      // caller-supplied overlayClassName layers on top instead of replacing it.
      overlayClassName={
        props.overlayClassName
          ? `uidropdown-overlay ${props.overlayClassName}`
          : "uidropdown-overlay"
      }
      placement={props.placement}
      overlay={menu}
      trigger={props.trigger || ["click"]}
    >
      {props.children}
    </Dropdown>
  );
};

export { UIDropdown };
